import { Validator, ValidatorFn, NG_VALIDATORS, AbstractControl } from '@angular/forms';
import { Directive } from '@angular/core';
import { Cpf } from 'angular-validate-br/esm2015/lib/functions/cpf';
import { Cnpj } from 'angular-validate-br/esm2015/lib/functions/cnpj';
import { Input } from '@angular/core';

@Directive({
  selector: '[valCpfCnpj][ngModel]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: CpfCnpjValidatorDirective,
      multi: true
    }
  ]
})
export class CpfCnpjValidatorDirective implements Validator {
  private validator: ValidatorFn;
  private _onChange: () => void;

  @Input()
  get validation(): ValidatorFn | null { return this.validator; }

  set validation(value: ValidatorFn | null) {
    this.validator =  value;
    if (this._onChange) { this._onChange(); }
  }

  constructor() {
    this.validator = this.cpfcnpjValidator();
  }

  validate (c: AbstractControl) {
    return this.validator(c);
  }

  private cpfcnpjValidator (): ValidatorFn {
    return (c: AbstractControl) => {
      const isValid = new Cpf(c.value).validate() || new Cnpj(c.value).validate();
      if (isValid) {
        return null;
      } else {
        return {
          cpfcnpjValidator: {
            valid: false
          }
        };
      }
    };
  }

  registerOnValidatorChange(fn: () => void): void { this._onChange = fn; }
}
